import styled from 'styled-components';
import {Wrapper} from '../Button/style';

export const Option = styled.div`
  position: relative;
  padding: 10px 10px 25px;
  border-top: 2px solid ${(props) => props.theme.lightTransparent};

  ${Wrapper}:after {
    content: '';
    position: absolute;

    ${(p) => p.theme.fitContainerStyle}
  }
`;
